import React from "react";
import { X } from "lucide-react";
import PanelDeleteIconButton from "../../draggable-panels/PanelDeleteIconButton";
import Tooltip from "../../ui/Tooltip";

export default function NodeInspectorHeader({
  accent,
  defaultKindName,
  displayName,
  onClose,
  onDelete,
  canDelete = true,
}) {
  return (
    <div
      className="flex items-center gap-2 border-b border-gray-700 px-4 py-3"
      style={{ backgroundColor: "rgba(58, 58, 62, 1)" }}
    >
      <span
        className="inline-block h-2 w-2 shrink-0 rounded-full"
        style={{ backgroundColor: accent }}
        aria-hidden="true"
      />
      <div className="min-w-0 flex-1">
        <div className="text-xs text-gray-400">Inspector ? {defaultKindName}</div>
        <div className="truncate text-sm font-semibold text-gray-100">{displayName}</div>
      </div>
      {onClose ? (
        <Tooltip content="Close inspector">
          <button
            type="button"
            aria-label="Close inspector"
            onClick={(e) => {
              e.stopPropagation();
              onClose(e);
            }}
            className="flex h-7 w-7 shrink-0 items-center justify-center rounded text-gray-400 hover:bg-gray-700 hover:text-gray-100"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </Tooltip>
      ) : null}
      {onDelete ? (
        <PanelDeleteIconButton
          ariaLabel="Delete node"
          title={canDelete ? "Delete this node from the tree" : "Root node cannot be deleted"}
          onClick={() => {
            if (!canDelete) return;
            onDelete();
          }}
          disabled={!canDelete}
          className={canDelete ? "h-7 w-7 p-0" : "h-7 w-7 p-0 cursor-not-allowed"}
          iconClassName="h-3.5 w-3.5"
        />
      ) : null}
    </div>
  );
}
